export const RctBenches = [
  {
    railway_bench_code: "ADI",
    railway_bench_name: "AHMEDABAD",
    id: 1,
  },
  {
    railway_bench_code: "ALD",
    railway_bench_name: "ALLAHABAD",
    id: 2,
  },
  {
    railway_bench_code: "AMVT",
    railway_bench_name: "AMRAVATI",
    id: 3,
  },
  {
    railway_bench_code: "SBC",
    railway_bench_name: "BANGALORE",
    id: 4,
  },
  {
    railway_bench_code: "BPL",
    railway_bench_name: "BHOPAL",
    id: 19,
  },
  {
    railway_bench_code: "BBS",
    railway_bench_name: "BHUBANESWAR",
    id: 5,
  },
  {
    railway_bench_code: "CDG",
    railway_bench_name: "CHANDIGARH",
    id: 6,
  },
  {
    railway_bench_code: "MAS",
    railway_bench_name: "CHENNAI",
    id: 20,
  },
  {
    railway_bench_code: "DLI",
    railway_bench_name: "DELHI",
    id: 7,
  },
  {
    railway_bench_code: "ERS",
    railway_bench_name: "ERNAKULAM",
    id: 8,
  },
  {
    railway_bench_code: "GKP",
    railway_bench_name: "GORAKHPUR",
    id: 9,
  },
  {
    railway_bench_code: "GHY",
    railway_bench_name: "GUWAHATI",
    id: 10,
  },
  {
    railway_bench_code: "JP",
    railway_bench_name: "JAIPUR",
    id: 11,
  },
  {
    railway_bench_code: "KOL",
    railway_bench_name: "KOLKATA",
    id: 12,
  },
  {
    railway_bench_code: "LKO",
    railway_bench_name: "LUCKNOW",
    id: 13,
  },
  {
    railway_bench_code: "MCC",
    railway_bench_name: "MUMBAI",
    id: 14,
  },
  {
    railway_bench_code: "NGP",
    railway_bench_name: "NAGPUR",
    id: 15,
  },
  {
    railway_bench_code: "PNBE",
    railway_bench_name: "PATNA",
    id: 16,
  },
  {
    railway_bench_code: "RNC",
    railway_bench_name: "RANCHI",
    id: 17,
  },
  {
    railway_bench_code: "SC",
    railway_bench_name: "SECUNDERABAD",
    id: 18,
  },
  {
    railway_bench_code: "BSB",
    railway_bench_name: "VARANASI",
    id: 66,
  },
];

//   API Response

//   {
//     "data": [
//         {
//             "railway_bench_code": "ADI",
//             "railway_bench_name": "AHMEDABAD",
//             "id": 1
//         },
//         {
//             "railway_bench_code": "ALD",
//             "railway_bench_name": "ALLAHABAD",
//             "id": 2
//         },
//         {
//             "railway_bench_code": "AMVT",
//             "railway_bench_name": "AMRAVATI",
//             "id": 3
//         },
//         {
//             "railway_bench_code": "SBC",
//             "railway_bench_name": "BANGALORE",
//             "id": 4
//         },
//         {
//             "railway_bench_code": "BPL",
//             "railway_bench_name": "BHOPAL",
//             "id": 19
//         },
//         {
//             "railway_bench_code": "BBS",
//             "railway_bench_name": "BHUBANESWAR",
//             "id": 5
//         },
//         {
//             "railway_bench_code": "CDG",
//             "railway_bench_name": "CHANDIGARH",
//             "id": 6
//         },
//         {
//             "railway_bench_code": "MAS",
//             "railway_bench_name": "CHENNAI",
//             "id": 20
//         },
//         {
//             "railway_bench_code": "DLI",
//             "railway_bench_name": "DELHI",
//             "id": 7
//         },
//         {
//             "railway_bench_code": "ERS",
//             "railway_bench_name": "ERNAKULAM",
//             "id": 8
//         },
//         {
//             "railway_bench_code": "GKP",
//             "railway_bench_name": "GORAKHPUR",
//             "id": 9
//         },
//         {
//             "railway_bench_code": "GHY",
//             "railway_bench_name": "GUWAHATI",
//             "id": 10
//         },
//         {
//             "railway_bench_code": "JP",
//             "railway_bench_name": "JAIPUR",
//             "id": 11
//         },
//         {
//             "railway_bench_code": "KOL",
//             "railway_bench_name": "KOLKATA",
//             "id": 12
//         },
//         {
//             "railway_bench_code": "LKO",
//             "railway_bench_name": "LUCKNOW",
//             "id": 13
//         },
//         {
//             "railway_bench_code": "MCC",
//             "railway_bench_name": "MUMBAI",
//             "id": 14
//         },
//         {
//             "railway_bench_code": "NGP",
//             "railway_bench_name": "NAGPUR",
//             "id": 15
//         },
//         {
//             "railway_bench_code": "PNBE",
//             "railway_bench_name": "PATNA",
//             "id": 16
//         },
//         {
//             "railway_bench_code": "RNC",
//             "railway_bench_name": "RANCHI",
//             "id": 17
//         },
//         {
//             "railway_bench_code": "SC",
//             "railway_bench_name": "SECUNDERABAD",
//             "id": 18
//         },
//         {
//             "railway_bench_code": "BSB",
//             "railway_bench_name": "VARANASI",
//             "id": 66
//         }
//     ],
//     "error": ""
// }
